import { Component, OnInit, EventEmitter, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';

//  Components
import { ViewReviewersComponent, ReviewersModalWindow } from '../reviewer/viewReviewers.component';
import { ViewAbstractComponent, AbstractModalWindow } from './viewAbstract.component';
import { CreateReviewComponent, ReviewModalWindow } from '../review/createReview.component';

//  Services
import { AuthenticationService } from '../../services/authentication.service';
import { AbstractService } from '../../services/abstract.service';
import { ReviewService } from '../../services/review.service';

//  Libraries
import { Overlay, overlayConfigFactory } from 'angular2-modal';
import { Modal, BSModalContext } from 'angular2-modal/plugins/bootstrap';

@Component({
  selector: 'abstract-component',
  templateUrl: './abstract.component.html',
  providers: []
})

export class AbstractComponent implements OnInit {

  activeRoute: String;
  activeView: string = 'reviews';
  abstracts: any = [];
  reviews: any = [];
  session: any = {};
  searchTerm: string = '';
  orderByArray = ['section'];
  showFilters: boolean = false;
  activeFilter: string = '';
  filterLock: boolean = false;
  private interval;
  reviewColumnFilters = {
    type: [],
    section: [],
    student: []
  };
  abstractColumnFilters = {
    type: [],
    section: [],
    student: []
  };

  constructor(
    private router: Router,
    private authService: AuthenticationService,
    private abstractService: AbstractService,
    private reviewService: ReviewService,
    public modal: Modal,
    overlay: Overlay,
    vcRef: ViewContainerRef) {

    overlay.defaultViewContainer = vcRef;
  }

  ngOnInit() {

    this.session = this.authService.retrieveSession();

    this.authService.Session$.subscribe(session => {
      this.session = session;
      this.activeRoute = this.router.url;
      if (session && session.reviewer) {
        this.getReviews();
      }
    });

    this.reviewService.UpdateReviewEvent$.subscribe(event => {
      this.getReviews();
    });

    if (!this.session || !this.session.reviewer) {
      //this.modal.open(ViewReviewersComponent, overlayConfigFactory({ id: null }, BSModalContext));
      this.getUser(this.session.username);
    }

    if (this.session.reviewer) {
      this.getReviews();
    }
  }

  getUser(authUserName) {
    this.reviewService.getReviewsFromUsername(authUserName)
      .subscribe(user => {
        this.session.reviewer = user;
        this.getReviews();
      }, err => {
        console.log(err);
      });
  }
  getAbstracts() {
    this.activeView = 'abstracts';
    this.searchTerm = '';

    this.abstractService.getAbstracts()
      .subscribe(abstracts => {
        this.abstracts = abstracts.aaData;
        
        this.getAbstractUniqueColumnFilters(this.abstracts);
      }, err => {
        console.log(err);
      });
  }

  getReviews() {

    this.activeView = 'reviews';
    this.searchTerm = '';
    
    this.reviewService.getReviewsForReviewer(this.session.reviewer.uuid)
      .subscribe(reviews => {
        this.reviews = reviews.aaData;
        this.getReviewUniqueColumnFilters(this.reviews);
      }, err => {
        console.log(err);
      });
  }

  openAbstractModal(id: number) {
    this.modal.open(ViewAbstractComponent, overlayConfigFactory({ id: id }, BSModalContext));
  }

  openReviewModal(id: string) {
    this.modal.open(CreateReviewComponent, overlayConfigFactory({ id: id }, BSModalContext));
  }

  sortReviews(sort: any) {

    var sortIndex = this.orderByArray.findIndex(o => o == sort);

    this.orderByArray = [];

    if (sortIndex == -1) {
      this.orderByArray.push(sort);
    } else {
      this.orderByArray.push('-' + sort)
    }
  }

  sortAbstracts(sort: any) {

    var sortIndex = this.orderByArray.findIndex(o => o == sort);

    this.orderByArray = [];

    if (sortIndex == -1) {
      this.orderByArray.push(sort);
    } else {
      this.orderByArray.push('-' + sort)
    }
  }

  getAbstractUniqueColumnFilters(abstracts: any[]) {
    for (let abstract of abstracts) {
      if (this.abstractColumnFilters.type.indexOf(abstract.type) == -1) {
        this.abstractColumnFilters.type.push(abstract.type);
      }
      if (this.abstractColumnFilters.section.indexOf(abstract.section + '/' + abstract.subSection) == -1) {
        this.abstractColumnFilters.section.push(abstract.section + '/' + abstract.subSection);
      }
      if (this.abstractColumnFilters.student.indexOf(abstract.student) == -1) {
        this.abstractColumnFilters.student.push(abstract.student);
      }
    }
  }

  getReviewUniqueColumnFilters(reviews: any[]) {
    for (let review of reviews) {
      if (this.reviewColumnFilters.type.indexOf(review.type) == -1) {
        this.reviewColumnFilters.type.push(review.type);
      }
      if (this.reviewColumnFilters.section.indexOf(review.section) == -1) {
        this.reviewColumnFilters.section.push(review.section);
      }
      if (this.reviewColumnFilters.student.indexOf(review.student) == -1) {
        this.reviewColumnFilters.student.push(review.student);
      }
    }
  }

  setFilter(filter: string) {
    this.searchTerm = filter;
  }

  showFilter(filter: string, enabled: boolean) {

    this.activeFilter = filter;

    if (enabled) {
      if (!this.filterLock) {
        this.showFilters = enabled;
      }
    } else {
      this.searchTerm = '';
      this.startFilterLock();
      this.showFilters = enabled;
    }
  }

  startFilterLock() {
    var self = this;
    this.filterLock = true;
    this.interval = setInterval(function () {
      self.filterLock = false;
      self.stopFilterLock();
    }, 1000);
  }

  stopFilterLock() {
    clearInterval(this.interval);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/abstract/abstract.component.ts